import React, { useEffect, useState } from 'react';
import Button from '../../NecttosComp/Button/Button';
import { Table, Tbody, Td, Th, Thead, Tr } from '../../NecttosComp/Table/Table';
import Input2 from '../../NecttosComp/Input/Input2';

function CustomKey({ currentList, setCurrentList, isBucket = false, dropdown, searchQuery, seletedRole }) {
	const [optionModal, setOptionModal] = useState(null);
	const [filters, setFilters] = useState({
		_id: '',
		name: '',
		shortName: '',
		category: '',
		type: '',
	});
	const [filteredList, setFilteredList] = useState(currentList);

	const handleFilterChange = (key, value) => {
		setFilters((prev) => ({
			...prev,
			[key]: value,
		}));
	};

	useEffect(() => {
		if (currentList) {
			const filteredList = currentList.filter((item) => {
				return (filters._id ? item._id.toLowerCase().includes(filters._id.toLowerCase()) : true) && (filters.name ? item.name.toLowerCase().includes(filters.name.toLowerCase()) : true) && (filters.shortName ? item.shortName.toLowerCase().includes(filters.shortName.toLowerCase()) : true) && (filters.category ? item.category.toLowerCase().includes(filters.category.toLowerCase()) : true && (filters.type ? item.type.toLowerCase().includes(filters.type.toLowerCase()) : true));
			});
			setFilteredList(filteredList);
		}
	}, [filters, currentList]);

	const handleToggleNeeded = (_id, neededStatus) => {
		const updatedData = currentList?.map((item) => (item._id === _id ? { ...item, needed: neededStatus } : item));
		setCurrentList(updatedData);
	};

	const handleAddItem = () => {
		if (optionModal.type === 'dropdown') {
			if (optionModal?.newItem?.trim() !== '') {
				setOptionModal({
					...optionModal,
					options: [...optionModal.options, optionModal.newItem.trim()],
					newItem: '',
				});
			}
		} else if (optionModal.type === 'text' || optionModal.type === 'number') {
			setOptionModal({
				...optionModal,
				options: optionModal.newItem,
				newItem: '',
			});
		}
	};

	const handleRemoveItem = (index) => {
		setOptionModal({
			...optionModal,
			options: optionModal.options.filter((_, i) => i !== index),
		});
	};

	const handleSaveOption = () => {
		setOptionModal(false);
	};

	return (
		<>
			<Table width='100%' innerWidth={['5%', '24%', '24%', '15%', '19%', '25%']}>
				<Thead>
					<Tr>
						<Th position={0}>Sl.No.</Th>
						<Th padding='0' position={1}>
							<div className='flex items-center h-[40px] m-0 p-0 rounded'>
								<select value={filters.category} onChange={(e) => handleFilterChange('category', e.target.value)} className='w-full h-[40px]  bg-gray-800 text-white    '>
									<option value=''>All Categories</option>
									{dropdown?.map((option) => (
										<option key={option} value={option}>
											{option}
										</option>
									))}
								</select>
							</div>
						</Th>
						<Th position={2}>Name</Th>
						<Th position={3}>Short Name</Th>
						<Th padding='0' position={4}>
							<div className='flex items-center h-[40px] m-0 p-0 rounded'>
								<select value={filters.type} onChange={(e) => handleFilterChange('type', e.target.value)} className='w-full h-[40px]  bg-gray-800 text-white    '>
									<option value=''>All Types</option>
									{['text', 'number', 'date', 'array', 'dropdown', 'email']?.map((option) => (
										<option key={option} value={option}>
											{option}
										</option>
									))}
								</select>
							</div>
						</Th>
						<Th position={8} width='400px'>
							Action
						</Th>
					</Tr>
				</Thead>
			</Table>
			<div className='h-full w-full overflow-auto'>
				<Table width='100%' innerWidth={['5%', '25%', '25%', '15%', '20%', '20%']}>
					<Tbody>
						{Array.isArray(currentList) &&
							currentList.length > 0 &&
							filteredList
								?.filter((x) => x.needed === !isBucket && (searchQuery ? x.name.toLowerCase().includes(searchQuery.toLowerCase()) : true))
								?.map((item, index) => (
									<Tr key={index}>
										<Td index={index} position={0}>
											{index + 1}
										</Td>
										<Td index={index} position={1}>
											{item?.category.length > 20 ? item?.category.slice(0, 30) + '...' : item?.category}
										</Td>
										<Td index={index} position={2}>
											{item?.name.length > 20 ? item?.name.slice(0, 30) + '...' : item?.name}
										</Td>
										<Td index={index} position={3}>
											{item?.shortName}
										</Td>
										<Td index={index} position={4}>
											{item?.type}
										</Td>
										{isBucket ? (
											<Td index={index} position={5}>
												<Button type='save' onClick={() => handleToggleNeeded(item._id, true)}>
													Add
												</Button>
											</Td>
										) : (
											<Td index={index} position={5}>
												<div className='flex gap-2'>
													<Button type='download' onClick={() => setOptionModal(item)}>
														Manage
													</Button>
													<Button type='fetch' onClick={() => handleToggleNeeded(item._id, false)}>
														Remove
													</Button>
												</div>
											</Td>
										)}
									</Tr>
								))}
					</Tbody>
				</Table>
			</div>

			{optionModal && (
				<div className='fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex justify-center items-center z-50'>
					<div className='bg-white p-6 rounded-lg shadow-lg w-2/3'>
						<h2 className='text-2xl font-bold mb-4'>Edit Options for {optionModal.name}</h2>

						{/* Edit Option Fields */}
						{!isBucket && (
							<>
								<Input2
									state={optionModal}
									setState={(state) => {
										setCurrentList((prevData) => prevData?.map((x) => (x._id === optionModal._id ? { ...x, priority: state['priority'] } : x)));
										setOptionModal((prevData) => ({ ...prevData, priority: state['priority'] }));
									}}
									className='m-0 p-0 w-full'
									width='100%'
									fieldName='Priority'
									returnKey='priority'
									options={['Emergency', 'High', 'Medium', 'Low']}
									type='drop'
								/>
								<Input2
									type='drop'
									state={optionModal}
									returnKey={'category'}
									fieldName='category'
									options={[...dropdown, 'other']}
									setState={(state) => {
										setCurrentList((prevData) => prevData?.map((x) => (x._id === optionModal._id ? { ...x, category: state['category'] } : x)));
										setOptionModal((prevData) => ({ ...prevData, category: state['category'] }));
									}}
									required
									error={false}
									errorMessage=''
									className='w-full'
									inputClassName='text-sm'
									inputWidth='w-full'
								/>

								{!dropdown.includes(optionModal.category) && (
									<Input2
										type='text'
										state={optionModal}
										returnKey={'category'}
										fieldName='category'
										setState={(state) => {
											setCurrentList((prevData) => prevData?.map((x) => (x._id === optionModal._id ? { ...x, category: state['category'] } : x)));
											setOptionModal((prevData) => ({ ...prevData, category: state['category'] }));
										}}
										required
										error={false}
										errorMessage=''
										className='w-full'
										inputClassName='text-sm'
										inputWidth='w-full'
									/>
								)}

								<div className='flex col justify-between py-4'>
									<Input2
										state={optionModal}
										setState={(state) => {
											setCurrentList((prevData) => prevData?.map((x) => (x._id === optionModal._id ? { ...x, start: state['start'] } : x)));
											setOptionModal((prevData) => ({ ...prevData, start: state['start'] }));
										}}
										className='m-0 p-0 w-[45%] px-1'
										width='100%'
										fieldName='Effect From'
										returnKey='start'
										type='date'
									/>
									<Input2
										state={optionModal}
										setState={(state) => {
											setCurrentList((prevData) => prevData?.map((x) => (x._id === optionModal._id ? { ...x, endDate: state['endDate'] } : x)));
											setOptionModal((prevData) => ({ ...prevData, endDate: state['endDate'] }));
										}}
										className='m-0 p-0 w-[45%] px-1'
										width='100%'
										fieldName='Effect to'
										returnKey='endDate'
										type='date'
									/>
								</div>

								<Input2
									state={optionModal}
									setState={(state) => {
										setCurrentList((prevData) => prevData?.map((x) => (x._id === optionModal._id ? { ...x, days: state['days'] } : x)));
										setOptionModal((prevData) => ({ ...prevData, days: state['days'] }));
									}}
									className='m-0 p-0 w-full'
									width='100%'
									fieldName='Days After Joining'
									returnKey='days'
									type='number'
								/>
								<Input2 type='drop' state={optionModal} returnKey={'whoFill'} fieldName='whoFill' options={seletedRole == 'student' || seletedRole == 'scholars' ? ['user', 'teacher', 'office'] : seletedRole == 'teacher' ? ['user', 'office'] : ['user']} setState={(state) => {
										setCurrentList((prevData) => prevData?.map((x) => (x._id === optionModal._id ? { ...x, whoFill: state['whoFill'] } : x)));
										setOptionModal((prevData) => ({ ...prevData, whoFill: state['whoFill'] }));
									}} required error={false} errorMessage='' className='w-full' inputClassName='text-sm' inputWidth='w-full' />
							</>
						)}

						{/* Filter & Add New Item Section */}
						{optionModal.type === 'dropdown' && (
							<div className='flex flex-col sm:flex-row items-center gap-4 mb-6'>
								<input
									type='text'
									placeholder='Search options...'
									className='flex-grow px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500'
									onChange={(e) =>
										setOptionModal({
											...optionModal,
											filter: e.target.value,
										})
									}
								/>
								<div className='flex items-center gap-2 flex-grow'>
									<input type='text' placeholder='Add new option' className='w-56 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500' value={optionModal.newItem} onChange={(e) => setOptionModal({ ...optionModal, newItem: e.target.value })} />
									<button className='bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-800 transition' onClick={handleAddItem}>
										Add
									</button>
								</div>
							</div>
						)}

						{/* Options List */}
						{optionModal.type === 'dropdown' && (
							<div className='bg-gray-50 p-4 rounded-lg shadow-inner max-h-80 overflow-y-auto'>
								<ul className='space-y-2'>
									{optionModal?.options
										?.filter((opt) => opt.toLowerCase().includes((optionModal.filter || '').toLowerCase()))
										?.map((item, index) => (
											<li key={index} className='flex justify-between items-center bg-white p-2 rounded-lg shadow-sm'>
												<span className='text-gray-700 flex-grow'>{item}</span>
												<button className='text-red-600 font-bold hover:text-red-800' onClick={() => handleRemoveItem(index)}>
													✕
												</button>
											</li>
										))}
								</ul>
								{optionModal?.options?.length === 0 && <p className='text-gray-500 text-center mt-4'>No options available.</p>}
							</div>
						)}

						{optionModal.type == 'array' && (
							<div className='bg-gray-50 p-4 rounded-lg shadow-inner max-h-80 overflow-y-auto'>
								<ul className='space-y-2'>
									{optionModal?.options?.map((item, index) => (
										<li key={index} className='flex justify-between items-center bg-white p-2 rounded-lg shadow-sm'>
											<span className='text-gray-700 flex-grow'>{item.name}</span>
										</li>
									))}
								</ul>
								{optionModal?.options?.length === 0 && <p className='text-gray-500 text-center mt-4'>No options available.</p>}
							</div>
						)}

						<div className='flex justify-end mt-6'>
							<button className='bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition mr-2' onClick={() => setOptionModal(false)}>
								Close
							</button>
							<button className='bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-800 transition' onClick={handleSaveOption}>
								Save Options
							</button>
						</div>
					</div>
				</div>
			)}
		</>
	);
}

export default CustomKey;
